/* eslint-disable react/react-in-jsx-scope */
import axios from "axios"
import { motion } from "framer-motion"
import { useEffect, useState } from "react"
import { Card, CardBody, Col, Row, Spinner } from "reactstrap"
import "./CardProcesso.css"
import formatNumber from "./formatNumber"

const processStats = [
  {
    title: "Total de Processos Acompanhados",
    key: "totalProcessosAcompanhados",
    icon: "bx bx-folder",
    gradient: "linear-gradient(135deg, #6B8DE3 0%, #4318FF 100%)",
  },
  {
    title: "Hoje",
    key: "hoje",
    icon: "bx bx-calendar-check",
    gradient: "linear-gradient(135deg, #49B5C0 0%, #1A97F5 100%)",
  },
  {
    title: "Última Semana",
    key: "ultimaSemana",
    icon: "bx bx-calendar-week",
    gradient: "linear-gradient(135deg, #53B947 0%, #169F85 100%)",
  },
  {
    title: "Último Mês",
    key: "ultimoMes",
    icon: "bx bx-calendar",
    gradient: "linear-gradient(135deg, #FFAA2B 0%, #FB9678 100%)",
  },
]

const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
}

const cardVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", stiffness: 100, damping: 12 },
  },
}

const numberVariants = {
  hidden: { scale: 0.8, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: { type: "spring", stiffness: 100 },
  },
}

const CardProcesso = () => {
  const [processos, setProcessos] = useState({
    totalProcessosAcompanhados: 0,
    hoje: 0,
    ultimaSemana: 0,
    ultimoMes: 0
  })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchProcessStats = async () => {
      try {
        setLoading(true)
        const response = await axios.get(`${process.env.REACT_APP_API_EXT_LEADS}/api/processos/leads-stats`)
        
        setProcessos(response.data)
        setError(null)
      } catch (err) {
        console.error('Erro ao buscar estatísticas:', err)
        setError(err.response?.data?.message || err.message || 'Erro ao carregar dados')
      } finally {
        setLoading(false)
      }
    }

    fetchProcessStats()
  }, [])

  const renderProcessValue = key =>
    loading ? (
      <Spinner size="sm" color="light" />
    ) : error ? (
      <span className="text-white-50">Erro</span>
    ) : (
      formatNumber(processos[key] || 0)
    )

  return (
    <div className="dashboard-stats">
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <Card className="shadow-lg border-0 rounded-lg">
          <CardBody>
            <Row className="mb-4">
              <Col lg="12">
                <h3 className="text-gradient fw-bold">
                  Estatísticas de Processos - Leads
                </h3>
              </Col>
            </Row>
            <Row>
              {processStats.map(({ title, key, icon, gradient }, index) => (
                <Col lg="3" key={index}>
                  <motion.div variants={cardVariants}>
                    <Card
                      className="stat-card border-0 h-100"
                      style={{ background: gradient }}
                    >
                      <CardBody className="p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div className="stat-icon me-3">
                            <span className="rounded-circle bg-white bg-opacity-10 text-white">
                              <i className={`${icon} fs-4`} />
                            </span>
                          </div>
                          <h5 className="text-white mb-0 fw-semibold">
                            {title}
                          </h5>
                        </div>
                        <div className="mt-4">
                          <motion.div
                            variants={numberVariants}
                            className="d-flex align-items-center"
                          >
                            <h2 className="text-white mb-0 me-2 fw-bold">
                              {renderProcessValue(key)}
                            </h2>
                            <span className="badge bg-white bg-opacity-10 text-white">
                              Atual
                            </span>
                          </motion.div>
                        </div>
                      </CardBody>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </motion.div>
    </div>
  )
}

export default CardProcesso
